import React, { useState, useContext, useEffect, useRef } from 'react';
import { FaEye, FaPlay } from "react-icons/fa";
import { FaCheck } from 'react-icons/fa6';
import { Modal, Spinner } from "react-bootstrap";
import { uploadimagetoserver, updateremotefittingquriesswingstatus } from '../../../Api/contact';
import Loader2 from '../../DashboardComponents/Loader/Loader2';
import { ForwardFittingContext } from '../ForwardFittingContext';
import { getCurrentUser } from "../../../Api/auth.js";
import videocontainerfirst from '../../../assets/images/video-container2.png';
import videocontainersecond from '../../../assets/images/video-container1.png';
import { IoClose } from 'react-icons/io5';
const API_URL = process.env.REACT_APP_API_URL;

const SwingData = ({ remoteData, remoteFittingQueriesId }) => {
  // State to store the videos

  const { updateremotefitting, remotefittingdata, setRemotefittingdata } = useContext(ForwardFittingContext);

  const [firstVideo, setFirstVideo] = useState(null);
  const [secondVideo, setSecondVideo] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const videoRef = useRef();
  const videoRef2 = useRef();

  // const generateThumbnail = (file) => {
  //   return new Promise((resolve, reject) => {
  //     const videoObjectUrl = URL.createObjectURL(file);

  //     const video = document.createElement('video');
  //     video.src = videoObjectUrl;
  //     video.preload = 'metadata';
  //     video.muted = true;
  //     video.playsInline = true;

  //     video.onloadedmetadata = () => {
  //       video.currentTime = 1;
  //     };

  //     video.onloadeddata = () => {
  //       video.play().then(() => {
  //         video.pause();

  //         const canvas = document.createElement('canvas');
  //         canvas.width = video.videoWidth;
  //         canvas.height = video.videoHeight;

  //         const ctx = canvas.getContext('2d');
  //         ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

  //         // Convert the canvas to a Blob instead of Data URL
  //         canvas.toBlob((blob) => {
  //           // Clean up
  //           URL.revokeObjectURL(videoObjectUrl);

  //           // Create a File object from the Blob
  //           const thumbnailFile = new File([blob], 'thumbnail.jpg', {
  //             type: 'image/jpeg'
  //           });

  //           resolve(thumbnailFile);
  //         }, 'image/jpeg');
  //       }).catch(error => {
  //         URL.revokeObjectURL(videoObjectUrl);
  //         reject(error);
  //       });
  //     };

  //     video.onerror = () => {
  //       URL.revokeObjectURL(videoObjectUrl);
  //       reject(new Error('Error loading video'));
  //     };
  //   });
  // };

  const generateThumbnail = (file) => {
    return new Promise((resolve, reject) => {
      const videoObjectUrl = URL.createObjectURL(file);
  
      const video = document.createElement('video');
      video.src = videoObjectUrl;
      video.preload = 'metadata';
      video.muted = true;
      video.playsInline = true;
  
      // Handle video metadata loading
      video.onloadedmetadata = () => {
        // Seek to the first second (or any desired frame)
        video.currentTime = 1;
      };
  
      // Wait until the video has seeked to the desired frame
      video.onseeked = async () => {
        try {
          // Add a small delay to ensure the frame is fully rendered
          await new Promise((resolve) => setTimeout(resolve, 200));
  
          const canvas = document.createElement('canvas');
          canvas.width = video.videoWidth || 320; // Fallback for width
          canvas.height = video.videoHeight || 240; // Fallback for height
  
          const ctx = canvas.getContext('2d');
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
          // Convert the canvas to a Blob (JPEG format)
          canvas.toBlob(
            (blob) => {
              // Clean up resources
              URL.revokeObjectURL(videoObjectUrl);
  
              if (!blob) {
                reject(new Error('Canvas conversion failed'));
                return;
              }
  
              const thumbnailFile = new File([blob], 'thumbnail.jpg', {
                type: 'image/jpeg',
              });
  
              resolve(thumbnailFile);
            },
            'image/jpeg',
            0.8 // Quality setting (0.8 = 80%)
          );
        } catch (error) {
          reject(new Error('Error processing video frame'));
        }
      };
  
      // Error handling
      video.onerror = () => {
        URL.revokeObjectURL(videoObjectUrl);
        reject(new Error('Error loading video'));
      };
  
      video.load(); // Explicitly load the video
    });
  };
  


  const uploadImageToServer = async (event, swing) => {
    try {
      event.preventDefault();
      setIsLoading(true);

      const videoFile = event.target.files[0];
      const thumbnail = await generateThumbnail(videoFile);

      const formData = new FormData();
      formData.append('image', event.target.files[0]);
      formData.append('remoteFittingQueriesId', remoteFittingQueriesId);
      formData.append('swing', swing);
      formData.append('thumbnail', thumbnail);


      const res = await uploadimagetoserver(formData);
      if (res.data?.status) {
        const resdata = res.data.data;
        const path = `swingdata.${swing}`;
        const filename = resdata.remotefittingdata.swingdata[swing];
        setRemotefittingdata(resdata.remotefittingdata);
      } else {
        alert(res.data.data[0]?.detail || 'Error uploading image');
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handdleChangeStatus = async () => {

    try {
      setIsLoading(true);

      const formData = {
        remoteFittingQueriesId: remoteFittingQueriesId,
        status: true
      }

      const res = await updateremotefittingquriesswingstatus(formData);


      if (res.data?.status) {
        const resdata = res.data.data;
        const path = `swingdata.status`;
        const status = resdata.remotefittingdata.swingdata.status;
        //updateremotefitting(path,status);
        console.log("remotefittingdata0000", remotefittingdata);
        setRemotefittingdata(resdata.remotefittingdata);
      }
      else {
        alert(res.data.data[0]?.detail || 'status no updated');
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
    finally {
      setIsLoading(false);
    }

  }

  useEffect(() => {
    console.log("remotefittingdata", remotefittingdata);
  }, [remotefittingdata]);


  useEffect(() => {
    console.log("remotefittingdata90909090", remoteData);
  }, [remoteData]);

  const [role_id, seRole_id] = useState(null);

  useEffect(() => {
    const getCurrentUserdata = getCurrentUser();
    // setUserdata(getCurrentUserdata.user);
    // setUser_id(getCurrentUserdata.user._id);


    if (getCurrentUserdata && getCurrentUserdata.user) {
      seRole_id(getCurrentUserdata.user.role_id);
    } else {
      console.error("Current user data is null or undefined");
    }

  }, []);


  const [metadata, setMetadata] = useState({
    duration: null,
    width: null,
    height: null,
    videoUrl: ''
  });

  // Ref to access the video element

  // Event handler for when the video's metadata is loaded
  const handleMetadata = (videoRef) => {
    if (videoRef.current) {
      setMetadata({
        duration: videoRef.current.duration, // Duration in seconds
        width: videoRef.current.videoWidth,  // Video width
        height: videoRef.current.videoHeight, // Video height
        videoUrl: videoRef.current.currentSrc, // Current video source URL
      });

      // if hight > then width then add object-fit cover

      // if (videoRef.current.videoHeight > videoRef.current.videoWidth) {
      //   videoRef.current.style.objectFit = 'fill';
      // } 
    }
  };


  const playerRefs = useRef([]);
  const [ironDataModal, setIronDataModal] = useState(false);
  const handleCloseModal = () => {
    setIronDataModal(false);
  };

  return (
    <>
      <div className="remotefittingnewdesign">
        <div
          className="swingdata row black_bg_box cf mx-3 mt-4 "
          style={{ borderRadius: "40px", backgroundColor: "#1e2025" }}
        >
          <div className="club-fitting-card">
            <div className="gab_title ">
              <div className="collapsed d-flex align-items-center " >
                <div className="gab_icon m-0" style={{
                  backgroundColor: remoteData.swingdata.status ? "#99ea24" : "",
                }}>
                  <FaCheck />
                </div>
                <div className="gab_text ms-3"><h5 className='cf-title'>Film Swing</h5></div>
              </div>
            </div>

            {
              role_id == 4 && (<div className='gab_text' style={{ fontSize: '20px' }}>
                The first thing we need is videos of your swing. Watch the tutorial below to ensure we are getting the right angles.
              </div>)
            }


            {/* <div className='gab_text' style={{ fontSize: '20px' }}>
            The first thing we need is videos of your swing. Watch the tutorial below to ensure we are getting the right angles.
          </div> */}
          </div>
          {
            role_id == 4 && (<div className="col-12 col-12 my-4">
              <div eventKey="2" className="mobile-accordion" onClick={() => setIronDataModal(true)}>
                <div className="bg_green_light" style={{ backgroundColor: '#36454F' }}>
                  <div className="gs_fr_tops" id="lesson_card_1">
                    <div>
                      <div className="gab_title">
                        <div className="gab_text bg-accordion-title">
                          <h5>How to Film a Swing?</h5>
                        </div>
                        <div className="">
                          <div className="barplay_icon_item">
                            <FaEye size={15} color="#ffffff" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>)
          }
          {/* <div className="col-12 col-12 mt-4 mb-3  ">
          <div eventKey="2" className="mobile-accordion">
            <div className="bg_green_light" style={{ backgroundColor: '#36454F' }}>
              <div className="gs_fr_tops" id="lesson_card_1">
                <div>
                  <div className="gab_title">
                    <div className="gab_text bg-accordion-title">
                      <h5>How to Film a Swing?</h5>
                    </div>
                    <div className="">
                      <div className="barplay_icon_item">
                        <FaPlay size={15} color="#ffffff" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

          <div className="col-12 dashboard-se">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex justify-content-center gap-2">
                  {/* First Video Section */}
                  <div className="normal-post col-6 col-md-6 swing1_video">
                    {isLoading ? (
                      <div className="loading">
                        <Loader2 />
                      </div>
                    ) : (
                      <div className="card-videoo">
                        {
                          remotefittingdata?.swingdata?.status ? <></> : <>
                            <input
                              type="file"
                              accept=".mp4,.avi,.mkv"
                              id={`step1.swing1.fileID`}
                              style={{ display: "none" }}
                              onChange={(event) => uploadImageToServer(event, "swing1")}
                            /></>
                        }


                        {/* Video Container */}
                        <div
                          className="video-container1"
                          style={{
                            backgroundImage: !remoteData?.swingdata?.swing1
                              ? `url(${videocontainerfirst})`
                              : "none",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            borderRadius: "15px",
                          }}
                        >
                          {remoteData?.swingdata?.swing1 && (
                            <video
                              ref={videoRef}
                              playsInline
                              autoPlay={false}
                              controls
                              // preload="metadata"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "10px",
                              }}
                              poster={`${API_URL}thumbnails/${remotefittingdata?.swingdata?.thumbnail1}`}
                              controlsList="nodownload"
                              onLoadedMetadata={() => {
                                handleMetadata(videoRef);
                              }}
                            >
                              <source
                                src={`${API_URL}remotefittingvideo/${remotefittingdata?.swingdata?.swing1}`}
                                type="video/mp4"
                              />
                              Your browser does not support HTML5 video.
                            </video>
                          )}

                          {/* Custom Upload Button (Always Visible) */}

                          {
                            remotefittingdata?.swingdata?.status ? <></> : <>
                              <div className="custom-upload-btn">
                                <button
                                  className="btn-upload"
                                  onClick={() =>
                                    document.getElementById(`step1.swing1.fileID`).click()
                                  }
                                >
                                  <img
                                    src={require("../../../assets/images/photo-camera.png")}
                                    alt="upload"
                                  />
                                </button>
                              </div>
                            </>

                          }

                        </div>
                      </div>
                    )}
                  </div>





                  {/* Second Video Section */}
                  <div className="normal-post col-6 col-md-6 swing2_video">
                    {isLoading ? (
                      <div className="loading">
                        <Loader2 />
                      </div>
                    ) : (
                      <div className="card-videoo">

                        {
                          remotefittingdata?.swingdata?.status ? <></> : <>
                            <input
                              type="file"
                              accept=".mp4,.avi,.mkv"
                              id={`step2.swing1.fileID`}
                              style={{ display: "none" }}
                              onChange={(event) => uploadImageToServer(event, "swing2")}
                            />
                          </>

                        }


                        {/* Video Container */}
                        <div
                          className="video-container2"
                          style={{
                            backgroundImage: !remoteData?.swingdata?.swing2
                              ? `url(${videocontainersecond})`
                              : "none",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            borderRadius: "15px",
                          }}
                        >
                          {remoteData?.swingdata?.swing2 && (
                            <video
                              ref={videoRef2}
                              playsInline
                              autoPlay={false}
                              controls
                              // preload="metadata"
                              poster={`${API_URL}thumbnails/${remotefittingdata?.swingdata?.thumbnail2}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "10px",
                              }}
                              controlsList="nodownload"
                              onLoadedMetadata={() => {
                                handleMetadata(videoRef2);
                              }}
                            >
                              <source
                                src={`${API_URL}remotefittingvideo/${remotefittingdata?.swingdata?.swing2}`}
                                type="video/mp4"
                              />
                              Your browser does not support HTML5 video.
                            </video>
                          )}

                          {/* Custom Upload Button (Always Visible) */}

                          {
                            remotefittingdata?.swingdata?.status ? <></> : <>
                              <div className="custom-upload-btn">
                                <button
                                  className="btn-upload"
                                  onClick={() =>
                                    document.getElementById(`step2.swing1.fileID`).click()
                                  }
                                >
                                  <img
                                    src={require("../../../assets/images/photo-camera.png")}
                                    alt="upload"
                                  />
                                </button>
                              </div>
                            </>

                          }

                        </div>
                      </div>
                    )}
                  </div>



                </div>

              </div>
            </div>
          </div>

          <div className="save-attach d-flex align-items-center justify-content-between mt-3 mb-4 col-12">
            <button
              className="btn save-attach-btn col-12 py-4"
              style={{ backgroundColor: "rgb(153, 234, 36)" }}
              disabled={(remotefittingdata?.swingdata?.swing2 == "" || remotefittingdata?.swingdata?.swing1 == "") ||
                (remotefittingdata?.swingdata?.status)}
              onClick={handdleChangeStatus}
            >
              Save Golf Swing
            </button>
          </div>
        </div>
        <style>
          {`
        /* The video container takes the full width and height of the col-6 */
.video-container1 {
  position: relative;
  width: 100%;
  height: 600px;
  background-position: center top;
}
.video-container2 {
  position: relative;
  width: 100%;
  height: 600px;
  background-position: center top;
}

.card-videoo{
width: 100%;
height: 100%;}

@media only screen and (min-width: 280px) and (max-width: 480px) {
    .video-container1, .video-container2 {
        height: 80vw;
    }
}

@media only screen and (min-width: 481px) and (max-width: 767px) {
    .video-container1, .video-container2  {
        height: 75vw;
    }
}

@media only screen and (min-width: 768px) and (max-width: 990px) {
    .video-container1, .video-container2  {
        height: 580px;
        background-position: center center;
    }
}
@media only screen and (min-width: 991px) and (max-width: 1270px) {
    .video-container1, .video-container2  {
        height: 450px;
        background-position: center;
    }
}
@media only screen and (min-width: 1271px) and (max-width: 1600px) {
  .video-container1, .video-container2  {
    height: 540px;
    background-position: center ;
  }
}
@media only screen and (min-width: 1601px) and (max-width: 1900px) {
  .video-container1, .video-container2  {
    height: 70vh;
    background-position: center ;
  }
}
@media only screen and (min-width: 1901px) and (max-width: 2499px) {
  .video-container1, .video-container2  {
    height: 75vh;
    background-position: center ;
  }
}
@media only screen and (min-width: 2500px) {
  .video-container1, .video-container2  {
    height: 80vh;
    background-position: center ;
    }
}
    

/* Custom upload button is centered both horizontally and vertically */
.custom-upload-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2; /* Ensures it's above the video */
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto; /* Button remains clickable */
}

/* Styling the video to ensure it covers the container and keeps the aspect ratio */
video {
  width: 100%;
  height: 100%;
  // outline: 0.1px solid rgb(73, 73, 73);
  border-radius: .5rem; 
}
/* If no video, the container should keep its aspect ratio */
.video-container1::before {
  content: '';
  display: block;
  // padding-top: 150%; 
  background-color: transparent;
  // border: 1px solid #cccccc;
  border-radius: 0.5rem;
}
.video-container2::before {
  content: '';
  display: block;
  // padding-top: 150%; 
  background-color: transparent;
  // border: 2px solid #cccccc;
  border-radius: 0.5rem;
}
`}
        </style>
      </div>
      <Modal size="lg" centered show={ironDataModal} onHide={handleCloseModal} className="step card-radius popup-modal-dark">
        <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
          <div className='row d-flex justify-content-between align-items-center' >
            <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
            <div className="col-3 closing-icon d-flex align-items-center justify-content-end">

              <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal} aria-label="Close">
                <IoClose style={{ strokeWidth: '30px' }} />
              </button>
            </div>
          </div>
          <div className="row">
            <div className='col-12 mb-0'>
              <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
                <div id="player" className="v-video">
                  <iframe
                    ref={(el) => (playerRefs.current[0] = el)}
                    src="https://player.vimeo.com/video/1045495995?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    title="Your Video Title"
                    data-ready="true"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal >
      {/* <Modal
                show={ironDataModal}
                centered
                className="step card-radius popup-modal-dark"
            >
                <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding:'4px 15px' }}>
                <div className='row d-flex justify-content-between align-items-center' >
                                        <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                                        <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
                                           
                                            <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal} aria-label="Close">
                                                <IoClose style={{ strokeWidth: '30px' }}/>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className='col-12 mb-0'>
                                            <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
                                                <div id="player" className="v-video">
                                                    <iframe
                                                        ref={(el) => (playerRefs.current[0] = el)}
                                                        src="https://player.vimeo.com/video/1045495995?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                        frameBorder="0"
                                                        allow="autoplay; fullscreen; picture-in-picture"
                                                        allowFullScreen
                                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                        title="Your Video Title"
                                                        data-ready="true"
                                                    ></iframe>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                </Modal.Body>
            </Modal> */}
    </>
  );
};

export default SwingData;
